export default "__VITE_ASSET__CBSkIBzF__"